/**
 * @name setMegaMenuToggle
 * @description メガメニューの開閉をする
 * @param {Object} megaMenu メガメニューの要素
 * @param {class} openMegaMenu メガメニューの開くクラス
 * @param {const} closeMegaMenu メガメニューの閉じる関数
 */
export function setMegaMenuToggle() {
  const megaMenu = document.querySelectorAll('.globalNav .nav-menu__item:has(.mega-menu)');
  if (megaMenu.length === 0) return;

  class openMegaMenu {
    constructor(el) {
      this.el = el;
      this.el.addEventListener('mouseenter', () => {
        this.el.classList.add('--active');
        megaMenu.forEach((el) => el !== this.el && el.classList.remove('--active'));
      });
      this.el.addEventListener('mouseleave', () => this.el.classList.remove('--active'));
    }
  }

  const closeMegaMenu = () => megaMenu.forEach((el) => el.classList.remove('--active'));

  megaMenu.forEach((el) => new openMegaMenu(el));
  window.addEventListener('scroll', () => closeMegaMenu());
}